(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .filter("rolloverStatusCode", rolloverStatusCode);

  /** @ngInject */
  function rolloverStatusCode($translate) {
    return function (input) {
      for (var i = 0; i < 26; i++) {
        if (input === i + ".0") {
          return $translate.instant("ROLLOVER_STATUS_CODE_" + i);
        } else if (input === "98.0") {
          return $translate.instant("ROLLOVER_STATUS_CODE_98");
        } else if (input === "99.0") {
          return $translate.instant("ROLLOVER_STATUS_CODE_99");
        }
      }
    };
  }
})();
